export function determineOrbTimeUnit(setupDetails) {
  return 'MINUTES';
}